import {
  ArrayInput,
  Datagrid,
  required,
  SimpleFormIterator,
  TextField,
  TextInput,
  useRecordContext,
} from "react-admin";
import { MyEdit } from "../../ra-lb-tools/components/myMutator";
import { LockerTypeField, LockerTypeInput } from "../lockerTypes";
import { WithData } from "../../ra-lb-tools/components/withData";
import { LinkButton } from "../../ra-lb-tools/components/linkButton";
import { WithPermissions } from "../../ra-lb-tools/acl/withPermissions";
import { Edit } from "@mui/icons-material";
import { getValidResource } from "../../ra-lb-tools/acl/tools";

export const OrganizationSettingsField = () => {
  const organization = useRecordContext();
  if (!organization) return null;

  return (
    <WithData
      url={`/${getValidResource("organizations")}/${organization.id}/settings`}
      render={(data) => {
        data = data.lockerTypeDisplay || [];

        return (
          <Datagrid
            sx={{ marginTop: "10px" }}
            className="compact"
            resource="settings"
            data={data}
            total={data.length}
            bulkActionButtons={false}
            sort={{}}
          >
            <LockerTypeField source="lockerType" />
            <TextField source="displayName" />
          </Datagrid>
        );
      }}
    />
  );
};

export const EditOrganizationSettingsButton = ({ noLabel }) => {
  const organization = useRecordContext();

  if (!organization) return null;
  const path = `/${getValidResource("organizations")}/${
    organization.id
  }/settings`;

  return (
    <WithPermissions
      can={{
        resource: getValidResource("organizations"),
        action: "update_settings",
      }}
    >
      <LinkButton
        className="EditOrganizationSettingsButton"
        to={path}
        label={noLabel ? "" : "Settings"}
        onClick={(e) => e.stopPropagation()}
      >
        <Edit />
      </LinkButton>
    </WithPermissions>
  );
};

export const OrganizationSettingsUpdate = () => {
  return (
    <MyEdit
      customSegment="settings"
      idfield="organizationId"
      permissionAction="update_settings"
      columns={1}
    >
      <ArrayInput
        source="lockerTypeDisplay"
        label="Locker type display mapping"
      >
        <SimpleFormIterator inline={true}>
          <LockerTypeInput source="lockerType" validate={required()} />
          <TextInput source="displayName" validate={required()} />
        </SimpleFormIterator>
      </ArrayInput>
    </MyEdit>
  );
};
